import { defineStore } from "pinia";
import axios from 'axios';
import router from "@/router";
import { useUiStore } from '@/store/ui';

const apiUrl = process.env.VUE_APP_API_URL;

export const useAuthStore = defineStore("auth", {

    state: () => ({
        nickname: '',
        password: '',
        // 서버는 JSESSIONID(HttpOnly)를 세션으로 사용하므로 직접 읽을 수 없음
        // localStorage로 로그인 상태를 별도 관리
        token: localStorage.getItem('auth'),
        expirationTimer: null,
        tokenExpirationMinute: parseInt(localStorage.getItem('authExpMin') || '0'),
        loginError: '',
        loginLoading: false,
    }),

    actions: {

        startTimer() {
            if (this.expirationTimer) clearInterval(this.expirationTimer);
            this.expirationTimer = setInterval(() => {
                if (this.tokenExpirationMinute <= 1) {
                    this.tokenExpirationMinute = 0;
                    clearInterval(this.expirationTimer);
                    this.logout();
                } else {
                    this.tokenExpirationMinute--;
                    localStorage.setItem('authExpMin', String(this.tokenExpirationMinute));
                }
            }, 1000 * 60);
        },

        async login() {
            this.loginError = '';
            this.loginLoading = true;
            try {
                const response = await axios.post(apiUrl + '/admin/user/login', {
                    nickname: this.nickname,
                    password: this.password
                }, { withCredentials: true });

                if (response.status === 200) {
                    this.token = 'authenticated';
                    localStorage.setItem('auth', 'authenticated');
                    this.tokenExpirationMinute = 60;
                    localStorage.setItem('authExpMin', '60');
                    this.startTimer();
                    await router.push('/home');
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    this.loginError = '닉네임 또는 비밀번호가 올바르지 않습니다.';
                } else {
                    this.loginError = '로그인 중 오류가 발생했습니다.';
                }
            } finally {
                this.loginLoading = false;
            }
        },

        async refreshAuth() {
            try {
                const response = await axios.post(
                    apiUrl + '/admin/user/auth/refresh', {},
                    { withCredentials: true }
                );
                if (response.status === 200) {
                    this.tokenExpirationMinute = 60;
                    localStorage.setItem('authExpMin', '60');
                    if (this.expirationTimer) clearInterval(this.expirationTimer);
                    this.startTimer();
                    useUiStore().showSuccess('세션이 연장되었습니다.');
                }
            } catch (error) {
                useUiStore().showError('세션 연장에 실패했습니다.');
                console.error(error);
            }
        },

        logout() {
            if (this.expirationTimer) clearInterval(this.expirationTimer);
            this.token = undefined;
            this.tokenExpirationMinute = 0;
            localStorage.removeItem('auth');
            localStorage.removeItem('authExpMin');
            router.push('/login');
        },

        // 페이지 새로고침 후 타이머 재시작 (토큰은 localStorage로 복원되지만 타이머는 재설정 필요)
        resumeTimer() {
            if (this.token && this.tokenExpirationMinute > 0) {
                this.startTimer();
            }
        }
    }
});
